import React, { Component } from 'react';
import PropTypes from 'prop-types';
import heroImage from '../../../../images/heroImage.png';

//Components
import Image from '../../atoms/Image';
import FormSignUp from '../FormSignUp';

//Returning the component
class HeroHeader extends Component {
	render() {
		return (

			<div className="heroHeader">
				<div className="container">
					<div className="row heroHeader__content">
						<div className="col-sm-12 col-md-6 col-lg-6">
							<div className="heroHeader__image">
								<Image classType="" alt="Hero Image" src={heroImage} />
							</div>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-6">
							<div className="heroHeader__signUp">
								<FormSignUp/>
							</div>
						</div>
					</div>
				</div>
			</div>


		)
	}
}

//Making sure that it has a text property when it's declared
HeroHeader.propTypes = {
	sectionType: PropTypes.string,
	TextHeadingOneText: PropTypes.string,
	paragraphText: PropTypes.string,
	buttonText: PropTypes.string
}

export default HeroHeader;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/HeroHeader/HeroHeader.jsx